import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const ExtensionRequestsListView = lazy(() =>
	import('./components/views/ExtensionRequestsListView').then((m) => ({ default: m.ExtensionRequestsListView }))
);

/**
 * The Extension Requests routes.
 */
const extensionRequestsRoutes: FuseRouteItemType[] = [
	{
		path: 'extension-requests',
		element: <ExtensionRequestsListView />
	}
];

export default extensionRequestsRoutes;
